import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CustomerType } from './customer-type.interface';
import { CustomerTypeService } from './customer-type.service';

const service = new CustomerTypeService();

export interface CustomerTypeState {
   customerTypes: Array<CustomerType>;
}

const CustomerTypeStore: Module<CustomerTypeState, StoreState> = {
   namespaced: true,
   state: {
      customerTypes: [],
   },
   getters: {
      customerTypes: (state) => state.customerTypes,
   },
   mutations: {
      SET_CUSTOMER_TYPES(state, customerTypes: Array<CustomerType>) {
         state.customerTypes = customerTypes;
      },
   },
   actions: {
      async getCustomerTypes(context, query?: LocationQuery) {
         const response = await service.getCustomerTypes(query);
         context.commit('SET_CUSTOMER_TYPES', response.data);
         return response.data;
      },
   },
};

export default CustomerTypeStore;
